export const TAGS = [
  ['Feature', '#4CAF50', '#ffffff'],
  ['Improvement', '#164780', '#ffffff'],
  ['Bug Fix', '#bf0b50', '#ffffff'],
  ['Optimization', 'gold', 'black'],
  ['Integrations', '#f4c3fb', 'black'],
  ['Kiosks', '#e6fac3', 'black'],
  ['Web Embed', '#ffeac9', 'black'],
  ['Invoicing', '#deffc9', 'black'],
  ['Projects', '#c9ffe9', 'black'],
  ['Reports', 'lightblue', 'black'],
  ['Live Maps', '#c9ffe9', 'black'],
  ['Scripting', '#99FFFF', 'black'],
  ['Forms', 'lightblue', 'black'],
  ['Mobile', 'lightyellow', 'black'],
  ['Accessibility', 'lightblue', 'black'],
];
